
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings, Users } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from '@/components/ui/button';
import LogoutButton from '@/components/LogoutButton';

interface UserMenuProps {
  userRole?: { plan_tier?: string };
  isAdminOrHigher: boolean;
  isSuper: boolean;
  handleDashboard: () => void;
}

const UserMenu: React.FC<UserMenuProps> = ({
  userRole,
  isAdminOrHigher,
  isSuper,
  handleDashboard
}) => {
  const navigate = useNavigate();
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm">
          {userRole?.plan_tier === 'premium' ? 'פרמיום' : userRole?.plan_tier === 'professional' ? 'מקצועי' : 'בסיסי'}
          <Settings className="mr-2 h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>חשבון משתמש</DropdownMenuLabel>
        
        <DropdownMenuItem onClick={handleDashboard}>
          לוח הבקרה
        </DropdownMenuItem>
        
        {isAdminOrHigher && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuLabel>ניהול מערכת</DropdownMenuLabel>
            
            {isSuper && (
              <DropdownMenuItem onClick={() => navigate('/admin/users')}>
                <Users className="ml-2 h-4 w-4" />
                ניהול משתמשים
              </DropdownMenuItem>
            )}
          </>
        )}
        
        <DropdownMenuSeparator />
        
        <DropdownMenuItem>
          <LogoutButton variant="ghost" size="sm" className="w-full justify-start p-0" />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserMenu;
